import { Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import React from 'react';

import { track } from '~/src/dash/analytics/analytics';
import { IUser } from '~/src/dash/api/console-api';
import { IGraphDataTypes } from '~/src/dash/components/dashboard/dashboard-graph';
// TODO: Can't find HomeDashboardDataLatencyErrorKeys in the code anymore
import { HomeDashboardDataLatencyErrorKeys } from '~/src/dash/globals/constants';
import { ISelectedMetrics } from '~/src/dash/types/metrics';
import { noopVoid } from '~/src/dash/utils/noop';
import { StreamDashboardCardDataKeys } from '~/src/dash/views/networks/constants';

interface IProps {
  selectedMetrics: ISelectedMetrics;
  graphDataTypes: IGraphDataTypes;
  handleMetricsChange: (
    title: HomeDashboardDataLatencyErrorKeys | StreamDashboardCardDataKeys,
    color: string,
  ) => void;
  classes: { [key: string]: string };
  makeDot: (color: string) => JSX.Element;
  bidderFilterActive?: boolean;
  dealFilterActive?: boolean;
  toggleLiveData?: boolean;
  user: IUser;
}

export const DashboardDataToggles = (props: IProps) => {
  const {
    selectedMetrics,
    graphDataTypes,
    handleMetricsChange,
    classes,
    makeDot,
    bidderFilterActive,
    toggleLiveData,
    user,
    dealFilterActive,
  } = props;

  const trackEvent = (key_metric: string) => {
    track(
      'Dashboard - Click Key Metric',
      {
        key_metric,
      },
      user,
    );
  };

  // function to generate the text for the tooltip
  const generateTooltipText = (
    disabled: boolean,
    bidderFilterActive: boolean,
    dealFilterActive: boolean,
  ): string => {
    // if the component is not disabled, then we don't need to show the tooltip
    if (!disabled) {
      return '';
    }

    // the component is disabled, show the appropriate tooltip
    if (bidderFilterActive) {
      // inactive because bidder filter is active
      return 'Metric inactive while bidder filters active';
    } else if (dealFilterActive) {
      // inactive because deal filter is active
      return 'Metric inactive while deal filters active';
    }
    // inactive because bidder filter is inactive
    return 'Metric inactive while bidder filters inactive';
  };

  return (
    <Grid container spacing={2}>
      {Object.keys(graphDataTypes).map((key: HomeDashboardDataLatencyErrorKeys) => {
        let disabled = false;
        if (!toggleLiveData && !bidderFilterActive) {
          disabled = [
            'BidRequests',
            'BidResponses',
            'WinningBids',
            'BidResponseRate',
            'BidTimeoutsRate',
          ].includes(key);
        } else if (bidderFilterActive || !!dealFilterActive) {
          disabled = [
            'EndpointRequests',
            'EventAuctionInits',
            'FillRate',
            'RenderedPodFillRate',
            'PodFillRate',
            'AuctionLatency',
            'EndpointLatency',
            'PodClearRate',
            'PaidPodClearRate',
          ].includes(key);
        }
        const { color, title } = graphDataTypes[key] || { color: 'black', title: 'undefined' };
        return (
          <Grid
            item
            lg={2}
            md={4}
            sm={6}
            xs={12}
            onClick={
              disabled
                ? noopVoid
                : () => {
                    if (!(key in selectedMetrics)) {
                      // only track when toggled ON
                      trackEvent(key);
                    }
                    handleMetricsChange(key, color);
                  }
            }
          >
            <Paper
              elevation={key in selectedMetrics && !disabled ? 1 : 0}
              style={
                disabled
                  ? { backgroundColor: '#EFEFEF', boxShadow: '0px 3px 4px #E2E2E2' }
                  : { boxShadow: '0px 3px 4px #E2E2E2' }
              }
            >
              <Tooltip
                title={generateTooltipText(disabled, !!bidderFilterActive, !!dealFilterActive)}
                disableFocusListener={!disabled}
                disableHoverListener={!disabled}
                disableTouchListener={!disabled}
              >
                <Grid
                  container
                  spacing={1}
                  justify='flex-start'
                  alignItems='center'
                  style={{
                    paddingTop: 10,
                    paddingBottom: 5,
                    paddingLeft: 10,
                  }}
                >
                  {makeDot(color)}
                  <Grid item>
                    <Typography
                      className={
                        key in selectedMetrics && !disabled
                          ? classes.dashboardToggleSelected
                          : classes.dashboardToggleNotSelected
                      }
                    >
                      {title}
                    </Typography>
                  </Grid>
                </Grid>
              </Tooltip>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
};
